<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh-toc" id="contents">CONTENTS</p>
<p class="cfmh"><span href="#/xhtml/cover" title="Link target outside of Sample">Cover</span></p>
<p class="cfmh"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="cfmh"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="cfmh"><span href="#/xhtml/authorsnote#aunote" title="Link target outside of Sample">Author’s Note</span></p>
<p class="cfmh-bot"><span href="#/xhtml/dramatis#dramatis" title="Link target outside of Sample">Dramatis Personae in Aquae Sulis</span></p>
<p class="cct"><a href="#/xhtml/chapter1#ch1">Chapter One</a></p>
<p class="cct"><a href="#/xhtml/chapter2#ch2">Chapter Two</a></p>
<p class="cct"><a href="#/xhtml/chapter3#ch3">Chapter Three</a></p>
<p class="cct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Chapter Four</span></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Chapter Five</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">Chapter Six</span></p>
<p class="cct"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="cct"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="cct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="cct"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="cct"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="cct"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="cct"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="cct"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="cct"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="cct"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="cct"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="cct"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Chapter Twenty-One</span></p>
<p class="cct"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Chapter Twenty-Two</span></p>
<p class="cct"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Chapter Twenty-Three</span></p>
<p class="cct"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Chapter Twenty-Four</span></p>
<p class="cct"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Chapter Twenty-Five</span></p>
<p class="cct"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">Chapter Twenty-Six</span></p>
<p class="cct"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">Chapter Twenty-Seven</span></p>
<p class="cct"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample">Chapter Twenty-Eight</span></p>
<p class="cct-bot"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample">Chapter Twenty-Nine</span></p>
<p class="cbmh"><span href="#/xhtml/glossary#gloss" title="Link target outside of Sample">Glossary</span></p>
<p class="cbmh"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cbmh"><span href="#/xhtml/adcard#adcard" title="Link target outside of Sample">Also by Kelli Stanley</span></p>
<p class="cbmh"><span href="#/xhtml/copyright#copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?11255336